import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';

import { Observable, of } from 'rxjs';
import { AspectRatioString } from 'src/modules/common';

import { GlobalBookingTravelClass } from '@fcom/core';
import { TripType } from '@fcom/core/interfaces';
import { DestinationSearchViewStyle } from '@fcom/destination-search/interfaces/destination-search.interface';

import { DestinationSearchBlockOffer } from '../../../cms/interfaces/destination-promo.interface';

@Component({
  selector: 'fin-destination-search-results-item',
  templateUrl: 'destination-search-results-item.component.html',
  styleUrls: ['destination-search-results-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DestinationSearchResultsItemComponent {
  isAmContinueModalOpen = false;
  flightHotelUrl: string;

  @Output()
  destinationClicked: EventEmitter<[DestinationSearchBlockOffer, GlobalBookingTravelClass, TripType]> =
    new EventEmitter();

  @Output()
  flightHotelClicked: EventEmitter<DestinationSearchBlockOffer> = new EventEmitter();

  @Output()
  calendarClicked: EventEmitter<[Event, DestinationSearchBlockOffer, GlobalBookingTravelClass, TripType]> =
    new EventEmitter();

  @Input()
  offer: DestinationSearchBlockOffer;

  @Input()
  viewStyle: DestinationSearchViewStyle;

  @Input()
  enableTeaser: boolean;

  @Input()
  showRoundTripPrices$: Observable<boolean> = of(false);

  @Input()
  aspectRatio$: Observable<AspectRatioString> = of('16x9');

  emitClick([travelClass, tripType]: [GlobalBookingTravelClass, TripType]): void {
    this.destinationClicked.emit([this.offer, travelClass, tripType]);
  }

  emitCalendarClick([event, travelClass, tripType]: [Event, GlobalBookingTravelClass, TripType]): void {
    this.calendarClicked.emit([event, this.offer, travelClass, tripType]);
  }

  openAmContinueModal({ amLink }: { amLink: string }): void {
    this.isAmContinueModalOpen = true;
    this.flightHotelUrl = amLink;
    this.flightHotelClicked.emit(this.offer);
  }

  closeAmContinueModal(): void {
    this.isAmContinueModalOpen = false;
  }
}
